var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLedger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_136_1038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.633 128.571H60.1V60.3789H128.292V110.912C128.292 120.696 120.418 128.571 110.633 128.571ZM44.35 128.571H35.6597C25.875 128.571 18 120.696 18 110.912V102.221H44.35V128.571ZM18 86.4714H44.35V60.1214H18V86.4714ZM102.221 18.2789H110.912C120.696 18.2789 128.571 26.1539 128.571 35.9386V44.35H102.221V18.2789ZM60.1 44.35H86.45V18H60.1V44.35ZM18 44.35V35.6597C18 25.8749 25.875 18 35.6597 18H44.35V44.35H18Z",
    fill: "#5D6370"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_136_1038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.571,
    height: 110.571,
    fill: "white",
    transform: "matrix(1 0 0 -1 18 128.571)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/ledger.42b9c7b23064abf45c29eeeee84de4e6.svg";
export { ForwardRef as ReactComponent };